import styled from 'styled-components';

export const AmenitiesDetailsLoaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 120rem;
  margin: 0 auto;
  width:100%;
  background-color:${props.theme.colors.white.base};
  border-radius:${props.theme.misc.borderRadius.large};
  margin-top:${props.theme.spacing.large.l20};

`,
);

export const AmenitiesDetailsLoaderHeaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding:${props.theme.spacing.large.l15};
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
  width:100%;
  justify-content: space-between;

`,
);

export const AmenitiesDetailsLoaderInnerHeaderDiv = styled.div(
  props => `

  display:flex;
  background-color:${props.theme.colors.blue.lightBlue};
  border-radius: ${props.theme.misc.borderRadius.small};
  width:13rem;
  height:1.6rem;

`,
);

export const AmenitiesDetailsLoaderListWrapDiv = styled.div(
  props => `

  display:flex;

  flex-direction: row;
  padding: ${props.theme.spacing.large.l15};
  margin-top:${props.theme.spacing.large.l20};
  margin-bottom:${props.theme.spacing.base};
  width:100%;

`,
);

export const AmenitiesDetailsLoaderListInnerWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-right: ${props.theme.spacing.large.l15};

`,
);

export const AmenitiesDetailsLoaderIconDiv = styled.div(
  props => `

  display:flex;
  background-color:${props.theme.colors.blue.lightBlue};
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-right: ${props.theme.spacing.small.s8};
  width:1.68rem;
  height:1.6rem;

`,
);

export const AmenitiesDetailsLoaderTitleWrapDiv = styled.div(
  props => `

  display:flex;
  background-color:${props.theme.colors.blue.lightBlue};
  border-radius: ${props.theme.misc.borderRadius.small};
  width:8rem;
  height:1.6rem;

`,
);

export const AmenitiesDetailsLoaderTitleLargeWrapDiv = styled.div(
  props => `

  display:flex;
  background-color:${props.theme.colors.blue.lightBlue};
  border-radius: ${props.theme.misc.borderRadius.small};
  width:12rem;
  height:1.6rem;

`,
);
